import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title
      ? `${title} - Collect Arena`
      : "Collect Arena - Knowledge Quiz Platform";

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
